module.exports = __webpack_public_path__ + "static/media/document.d8d30c12.svg";